import { computed } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import {
  AppointmentTypeKind,
  DayOfWeek,
} from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentTypeProvider";
import { $t } from "@/lib/i18nHelpers";
import weekLocaleHelper from "@/lib/weekLocaleHelpers";
import { Tab } from "@/types";

const { firstDayOfWeek, weekDaysToReorder } = weekLocaleHelper();

export const onlineAppointmentKinds = [
  AppointmentTypeKind.MESSAGING,
  AppointmentTypeKind.AUDIO_CALLS,
  AppointmentTypeKind.VIDEO_CALLS,
];

export const daysOfWeekMap = computed<Record<DayOfWeek, Record<string, TranslateResult>>>(() => ({
  [DayOfWeek.ALL]: {
    fullName: $t("All days"),
    tabName: $t("All"),
  },
  [DayOfWeek.MONDAY]: {
    fullName: $t("i18n.weekDays.monday.long"),
    tabName: $t("i18n.weekDays.monday.short"),
  },
  [DayOfWeek.TUESDAY]: {
    fullName: $t("i18n.weekDays.tuesday.long"),
    tabName: $t("i18n.weekDays.tuesday.short"),
  },
  [DayOfWeek.WEDNESDAY]: {
    fullName: $t("i18n.weekDays.wednesday.long"),
    tabName: $t("i18n.weekDays.wednesday.short"),
  },
  [DayOfWeek.THURSDAY]: {
    fullName: $t("i18n.weekDays.thursday.long"),
    tabName: $t("i18n.weekDays.thursday.short"),
  },
  [DayOfWeek.FRIDAY]: {
    fullName: $t("i18n.weekDays.friday.long"),
    tabName: $t("i18n.weekDays.friday.short"),
  },
  [DayOfWeek.SATURDAY]: {
    fullName: $t("i18n.weekDays.saturday.long"),
    tabName: $t("i18n.weekDays.saturday.short"),
  },
  [DayOfWeek.SUNDAY]: {
    fullName: $t("i18n.weekDays.sunday.long"),
    tabName: $t("i18n.weekDays.sunday.short"),
  },
}));

export const daysOfWeekTabs = computed<Tab[]>(() => {
  return Object.keys(DayOfWeek)
    .filter(day => day !== DayOfWeek.ALL)
    .map(day => ({
      text: daysOfWeekMap.value[day as keyof typeof DayOfWeek].tabName,
      value: DayOfWeek[day as keyof typeof DayOfWeek],
      order: weekDaysToReorder.includes(day.toLowerCase()) ? -1 : undefined,
    }));
});
export const weekStart = DayOfWeek[firstDayOfWeek.toUpperCase() as keyof typeof DayOfWeek];
